type Translations = Record<string, string>

export function mergeTranslations(translations: Translations[]): Translations {
  return translations.reduce((acc, translation) => {
    return { ...acc, ...translation }
  }, {})
}

export function addIdsToTranslations(translations: Translations): Translations {
  return Object.keys(translations).reduce((acc, key) => {
    return { ...acc, [key]: `${key} (${translations[key]})` }
  }, {})
}
